var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { Form, Modal, message, notification } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Input from '@fp-suite/core-ui/src/components/Input';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { PhotoAttachField, buildPackagePhotoName } from '../../camera';
import { fetchAttachments, uploadOrderPhotos } from '../../../redux/packing';
import { usePackingState, usePackingActions, usePrinterConnection } from '../hooks';
import { useWeightStationHeartbeat } from '../weight/useWeightStationHeartbeat';
import { WeightStationHeartbeatIndicator } from '../weight/WeightStationHeartbeatIndicator';
export var ClosePackageModal = function (_a) {
    var _b, _c, _d;
    var visible = _a.visible, packageSeqId = _a.packageSeqId, onClose = _a.onClose, onClosed = _a.onClosed;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var form = Form.useForm()[0];
    var _e = useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var _f = useState([]), photoFiles = _f[0], setPhotoFiles = _f[1];
    var _g = usePackingState(), shipmentId = _g.shipmentId, packageMetadataBySeqId = _g.packageMetadataBySeqId, boxTypes = _g.boxTypes, loadBoxTypes = _g.loadBoxTypes, loading = _g.loading, loadPackageWeight = _g.loadPackageWeight, shipmentItemSourceList = _g.shipmentItemSourceList;
    var orderId = (_b = shipmentItemSourceList === null || shipmentItemSourceList === void 0 ? void 0 : shipmentItemSourceList[0]) === null || _b === void 0 ? void 0 : _b.orderId;
    var handleClosePackage = usePackingActions().handleClosePackage;
    var refreshQzHostname = usePrinterConnection().refreshQzHostname;
    var isConfirmLoading = !!(loading === null || loading === void 0 ? void 0 : loading.closePackage) || isSubmitting;
    var metadataBoxTypeId = packageSeqId
        ? (_d = (_c = packageMetadataBySeqId === null || packageMetadataBySeqId === void 0 ? void 0 : packageMetadataBySeqId[packageSeqId]) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.shipmentBoxTypeId
        : undefined;
    var needsBoxTypeSelection = !metadataBoxTypeId;
    var _h = useWeightStationHeartbeat({
        enabled: visible,
        shipmentId: shipmentId,
        shipmentPackageSeqId: packageSeqId || undefined,
        loadPackageWeight: loadPackageWeight,
        onWeightReceived: function (weight) {
            form.setFieldsValue({ weight: String(weight) });
        }
    }), lastWeightReceivedAt = _h.lastWeightReceivedAt, weightAgeSeconds = _h.weightAgeSeconds, weightPulseClass = _h.weightPulseClass, hasActiveSource = _h.hasActiveSource, isQzConnected = _h.isQzConnected;
    useEffect(function () {
        if (!visible || !packageSeqId)
            return;
        void refreshQzHostname(false);
        setPhotoFiles([]);
        form.setFieldsValue({
            shipmentBoxTypeId: metadataBoxTypeId || undefined,
            weight: ''
        });
    }, [form, metadataBoxTypeId, packageSeqId, refreshQzHostname, visible]);
    useEffect(function () {
        if (!visible || !needsBoxTypeSelection)
            return;
        if (boxTypes.length === 0) {
            void loadBoxTypes();
        }
    }, [boxTypes.length, loadBoxTypes, needsBoxTypeSelection, visible]);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, shipmentBoxTypeId, resolvedHostname, weightResult, _a, weightSourceMessage, formWeight, packageWeight, uploadError_1, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!packageSeqId || !shipmentId || isConfirmLoading)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 14, 15, 16]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, form.validateFields(['shipmentBoxTypeId'])];
                case 2:
                    values = _c.sent();
                    shipmentBoxTypeId = metadataBoxTypeId || values.shipmentBoxTypeId;
                    return [4 /*yield*/, refreshQzHostname()];
                case 3:
                    resolvedHostname = _c.sent();
                    if (!resolvedHostname) return [3 /*break*/, 5];
                    return [4 /*yield*/, loadPackageWeight(shipmentId, packageSeqId)];
                case 4:
                    _a = _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _a = null;
                    _c.label = 6;
                case 6:
                    weightResult = _a;
                    weightSourceMessage = "Scale: " + ((weightResult === null || weightResult === void 0 ? void 0 : weightResult.scaleComputerId) || 'Not returned') + ". Hostname: " + ((weightResult === null || weightResult === void 0 ? void 0 : weightResult.hostname) || 'Not sent') + ".";
                    if (resolvedHostname &&
                        ((weightResult === null || weightResult === void 0 ? void 0 : weightResult.weight) === null || (weightResult === null || weightResult === void 0 ? void 0 : weightResult.weight) === undefined)) {
                        notification['warning']({
                            message: t('Warning'),
                            description: t('Could not retrieve package weight from the scale or shipment.') + " " + weightSourceMessage
                        });
                    }
                    formWeight = form.getFieldValue('weight');
                    packageWeight = (_b = weightResult === null || weightResult === void 0 ? void 0 : weightResult.weight) !== null && _b !== void 0 ? _b : parseFloat(formWeight);
                    if (!Number.isNaN(packageWeight)) return [3 /*break*/, 8];
                    return [4 /*yield*/, form.validateFields(['weight'])];
                case 7:
                    _c.sent();
                    return [2 /*return*/];
                case 8: return [4 /*yield*/, handleClosePackage({
                        shipmentPackageSeqId: packageSeqId,
                        shipmentBoxTypeId: shipmentBoxTypeId,
                        weight: packageWeight,
                        weightUomId: 'WT_lb'
                    })
                    // Upload only after the close succeeded, so a failed close leaves no orphan photos.
                ];
                case 9:
                    _c.sent();
                    if (!(photoFiles.length && orderId)) return [3 /*break*/, 13];
                    _c.label = 10;
                case 10:
                    _c.trys.push([10, 12, , 13]);
                    return [4 /*yield*/, dispatch(uploadOrderPhotos({
                            orderId: orderId,
                            files: photoFiles,
                            description: String(t('Package photo'))
                        })).unwrap()];
                case 11:
                    _c.sent();
                    dispatch(fetchAttachments({ orderId: orderId }));
                    return [3 /*break*/, 13];
                case 12:
                    uploadError_1 = _c.sent();
                    notification['warning']({
                        message: t('Warning'),
                        description: t('Package closed, but the photos could not be attached.')
                    });
                    return [3 /*break*/, 13];
                case 13:
                    form.resetFields();
                    setPhotoFiles([]);
                    onClosed();
                    return [3 /*break*/, 16];
                case 14:
                    error_1 = _c.sent();
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.errorFields) {
                        return [2 /*return*/];
                    }
                    message.error(t('Failed to close package'));
                    return [3 /*break*/, 16];
                case 15:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 16: return [2 /*return*/];
            }
        });
    }); }, [
        form,
        handleClosePackage,
        isConfirmLoading,
        loadPackageWeight,
        metadataBoxTypeId,
        onClosed,
        packageSeqId,
        refreshQzHostname,
        shipmentId,
        t,
        dispatch,
        orderId,
        photoFiles
    ]);
    return (_jsx(Modal, __assign({ title: packageSeqId ? t('Close Package') + " #" + packageSeqId : t('Close Package'), visible: visible, onCancel: function () {
            if (isConfirmLoading)
                return;
            onClose();
        }, onOk: handleSubmit, okText: t('Close Package'), confirmLoading: isConfirmLoading, cancelButtonProps: { disabled: isConfirmLoading }, maskClosable: !isConfirmLoading, keyboard: !isConfirmLoading }, { children: _jsxs(Form, __assign({ form: form, layout: 'vertical' }, { children: [needsBoxTypeSelection && (_jsx(Form.Item, __assign({ name: 'shipmentBoxTypeId', label: t('Box Type'), rules: [{ required: true, message: t('Please select box type') }] }, { children: _jsx(Dropdown, { searchable: true, placeholder: t('Select Box Type'), data: boxTypes }, void 0) }), void 0)), _jsx(Form.Item, __assign({ name: 'weight', label: t('Package Weight (lbs)'), rules: [
                        { required: true, message: t('Please enter package weight') },
                        { pattern: /^\d+(\.\d+)?$/, message: t('Enter a valid weight') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: t('Scan weight'), autoFocus: true }, void 0) }), void 0), _jsx(WeightStationHeartbeatIndicator, { packageSeqId: packageSeqId, lastWeightReceivedAt: lastWeightReceivedAt, weightAgeSeconds: weightAgeSeconds, weightPulseClass: weightPulseClass, hasActiveSource: hasActiveSource, isQzConnected: isQzConnected }, void 0), orderId && (_jsx("div", __assign({ className: 'mt-3' }, { children: _jsx(PhotoAttachField, { files: photoFiles, onChange: setPhotoFiles, disabled: isConfirmLoading, label: String(t('Add Photo')), modalTitle: String(t('Package Photo')), buildFileName: function (shotIndex) {
                            return buildPackagePhotoName(String(shipmentId), String(packageSeqId || ''), shotIndex);
                        } }, void 0) }), void 0))] }), void 0) }), void 0));
};
export default ClosePackageModal;
